// single tool
// props = {tool: DesignToolViewModel, textInputProps?: TextSketchInputProperties, icon: string, title: string}

import { TextSketchInputProperties } from 'cd-eft/business/MapViewInputManager/TextSketchInputProperties';
import React from 'react';
import { observer } from 'mobx-react';

import { DrawingToolViewModel } from '../viewModel/DrawingToolViewModel';

interface IDrawingToolViewProps {
  tool: DrawingToolViewModel;
  textInputProps?: TextSketchInputProperties;
  icon: string;
  title: string;
}

export const DrawingToolView = observer(function (props: IDrawingToolViewProps) {
  return (
    <button
      className={`esri-widget--button esri-interactive widget-button ${props.icon} ${
        props.tool.isActive && 'widget-button--active'
      }`}
      title={props.title}
      aria-label={props.title}
      onClick={async (e) => {
        await props.tool.toggleActivation();
      }}
    />
  );
});
